import { call } from "redux-saga/effects";

import { dictionaryApiService } from "../../../../actionService/apiService";

import endPoints from "./companySettings.endpoints";

import { ApiCallResult } from "../../../../types";

import UserSettingsDto from "../../../../../dto/Settings/UserSettingsDto";
import {
  AdminPanelCompanySettingsMapByCompanyIdResponseDto,
  AdminPanelCompanySettingsMapByOfficeTypesResponseDto,
} from "../../../../../dto/Settings/AdminPanelCompanySettingsDto";

const dictionaryCompanySettingsApi = {
  get: function* () {
    return (yield call([dictionaryApiService, dictionaryApiService.Get], endPoints.controller)) as ApiCallResult<UserSettingsDto>;
  },

  getMap: function* () {
    return (yield call(
      [dictionaryApiService, dictionaryApiService.Get],
      endPoints.map,
    )) as ApiCallResult<AdminPanelCompanySettingsMapByCompanyIdResponseDto>;
  },

  getMapByOfficeTypes: function* () {
    return (yield call(
      [dictionaryApiService, dictionaryApiService.Get],
      endPoints.mapByOfficeTypes,
    )) as ApiCallResult<AdminPanelCompanySettingsMapByOfficeTypesResponseDto>;
  },
};

export default dictionaryCompanySettingsApi;
